import { render, staticRenderFns } from "./CertifList.vue?vue&type=template&id=8fff3048&"
import script from "./CertifList.vue?vue&type=script&lang=js&"
export * from "./CertifList.vue?vue&type=script&lang=js&"
import style0 from "./CertifList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports